module.exports = __webpack_public_path__ + "static/img/1.aa7929f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fifa2026/flag_icons/1.png
// module id = EXZU
// module chunks = 1